module.exports = "https://cdn.thelire.com/ins/resource/ico_tab5_moreactive@2x.6bc0c1942bf33b043618fb29d1399ae0.png";